import {
	Component,
	Input,
	Output,
	OnChanges,
	OnDestroy,
	OnInit,
	EventEmitter,
	ViewEncapsulation
} from "@angular/core";
import { Router } from "@angular/router";
import { GlobalService } from "../../services/global/global.service";
import { DMVStoreService } from "../../services/dmv/dmv-store.service";
declare var window: any;
@Component({
	selector: "about-component",
	templateUrl: "./about.component.html",
	styleUrls: ["./about.component.scss"],
	encapsulation: ViewEncapsulation.None
})
export class AboutComponent implements OnInit {
	constructor(
		private router: Router,
		public globalService: GlobalService,
		public dmvStoreService: DMVStoreService
	) {}
	@Output() public close: EventEmitter<any> = new EventEmitter();
	public taxCollectorUrlText: string = "";

	ngOnInit() {
		this.dmvStoreService.agencyConfig$
			.subscribe(agencyConfig => {
				if (agencyConfig) {
					this.taxCollectorUrlText =
						agencyConfig.agencyDmvConfig.taxCollectorURL;

					if (this.taxCollectorUrlText) {
						this.taxCollectorUrlText = this.taxCollectorUrlText.replace(
							"http://",
							""
						);
						this.taxCollectorUrlText = this.taxCollectorUrlText.replace(
							"https://",
							""
						);
					}
				}
			})
			.unsubscribe();
	}

	backClicked() {
		this.close.emit();
		// window.openNav();
		// this.router.navigate([this.globalService.routerLastUrl.replace("/", "")], {
		// 	skipLocationChange: true
		// });
	}
}
